/**
 * Chat Message Model
 * Represents a single chat message in the system
 */
export class ChatMessage {
    constructor({
        id,
        message = "",
        response = "",
        messageType,
        timestamp,
        sessionId,
        metadata = {}
    }) {
        this.id = id || crypto.randomUUID();
        this.message = message;
        this.response = response;
        this.messageType = messageType; // 'user' | 'bot'
        this.timestamp = timestamp || new Date();
        this.sessionId = sessionId;
        this.metadata = metadata;
    }

    /**
     * Get the display text for this message
     */
    getDisplayText() {
        return this.messageType === 'bot' ? this.response : this.message;
    }

    /**
     * Check if this is a user message
     */
    isUserMessage() {
        return this.messageType === 'user';
    }

    /**
     * Check if this is a bot message
     */
    isBotMessage() {
        return this.messageType === 'bot';
    }

    /**
     * Get formatted timestamp
     */
    getFormattedTime() {
        return this.timestamp.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
    }

    /**
     * Create ChatMessage from API response
     */
    static fromApiResponse(apiData) {
        return new ChatMessage({
            id: apiData.message_id || apiData.id,
            message: apiData.message || "",
            response: apiData.response || "",
            messageType: apiData.message_type || 'bot',
            timestamp: new Date(apiData.timestamp),
            sessionId: apiData.session_id,
            metadata: apiData.metadata || {}
        });
    }

    /**
     * Convert to API format
     */
    toApiFormat() {
        return {
            message: this.message,
            session_id: this.sessionId,
            metadata: this.metadata
        };
    }

    /**
     * Create a user message
     */
    static createUserMessage(text, sessionId) {
        return new ChatMessage({
            message: text,
            messageType: 'user',
            sessionId: sessionId
        });
    }

    /**
     * Create a bot message
     */
    static createBotMessage(text, sessionId) {
        return new ChatMessage({
            response: text,
            messageType: 'bot',
            sessionId: sessionId
        });
    }
} 